<template>
  <div class="not-exist">
    <div
      class="error-icon"
      :style="`width:${width}px; height:${height}px;`"
    />
    <div class="error-reason">
      {{ content }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 130,
    },
    height: {
      type: Number,
      default: 130,
    },
    content: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped lang='less'>
  .not-exist {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .error-icon {
      background: url(~image/null.svg) no-repeat;
    }
  }
</style>
